export * from './delete-tour.service';
export * from './delete-tour.service.module';